import { useQuery } from '@tanstack/react-query'
import { Button, Tooltip } from 'antd'
import { Files } from 'lucide-react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { apiThreadsFilesListOptions } from 'src/api/squad'
import { ResizableDrawer } from 'src/components'
import { ChatFilesList } from 'src/components/chat'

import { resolveSquadFileUrl, toChatFileListItem } from '../squadFilesApi'

const ICON_SIZE = 15
const DRAWER_WIDTH = 380

type Props = {
  threadId: string | null
  appToken: string
}

/** Header button + drawer listing every file of the open chat. */
export const ChatFilesButton = ({ threadId, appToken }: Props) => {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)
  const { data, isLoading, isError, refetch } = useQuery({
    ...apiThreadsFilesListOptions({
      path: { id: threadId ?? '' },
      headers: { 'Saas-App-Token': appToken }
    }),
    enabled: open && !!threadId && !!appToken
  })

  if (!threadId) return null

  const label = t('workspaceHome.files.open')

  return (
    <>
      <Tooltip title={label}>
        <Button
          type="text"
          size="small"
          icon={<Files size={ICON_SIZE} />}
          aria-label={label}
          onClick={() => setOpen(true)}
        />
      </Tooltip>
      <ResizableDrawer
        open={open}
        onClose={() => setOpen(false)}
        title={t('workspaceHome.files.title')}
        defaultWidth={DRAWER_WIDTH}
        destroyOnHidden
      >
        <ChatFilesList
          files={(data ?? []).map(toChatFileListItem)}
          loading={isLoading}
          error={isError}
          onRetry={() => void refetch()}
          resolveUrl={resolveSquadFileUrl(appToken)}
        />
      </ResizableDrawer>
    </>
  )
}
